import request from "../../untils/request";

export function selectList(data) {

    return request({
        url: '/role/selectList',
        method: 'get',
        params: data
    })
}

export function detail(param) {

    return request({
        url: '/role',
        method: 'get',
        params: param
    })
}

export function add(data) {

    return request({
        url: '/role',
        method: 'post',
        data: data
    })
}

export function remove(param) {

    return request({
        url: '/role/'+param,
        method: 'delete',
    })
}
